import { Button } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";

export const CancelButton = () => {
  return (
    <Button
      type="button"
      variant="secondary"
      onClick={() => {
        history.back();
      }}
      css={buttonMargin}
    >
      キャンセル
    </Button>
  );
};
const buttonMargin = css({
  marginLeft: "16px",
});
